import Ably from 'ably';
import { api } from '../api/client';

let ablyClient: Ably.Realtime | null = null;

export async function getAblyClient(): Promise<Ably.Realtime | null> {
  if (ablyClient) return ablyClient;

  try {
    const data = await api.getAblyToken();
    if (!data.token) return null;

    ablyClient = new Ably.Realtime({
      authCallback: async (_, callback) => {
        try {
          const freshData = await api.getAblyToken();
          callback(null, freshData.token);
        } catch (err) {
          callback(err instanceof Error ? err.message : String(err), null);
        }
      },
    });

    return ablyClient;
  } catch {
    console.warn('Ably not available');
    return null;
  }
}
